export const START_WITH = 'startwith';
export const CONTAINS = 'contains';
